import styled, { css } from "styled-components";
import { FlexColumn, FlexRow } from "./common.styles";
import { LighterLittleText, Subtitle } from "./HXMobilePage.styles";
import { colors } from "healthex-common/colors";
import ErrorIcon from "@mui/icons-material/Error";
export const DocumentSelectionLabelContainer = styled(FlexRow) `
    margin-left: 8px;
    gap: 12px;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
`;
export const DocumentSelectionTextLabelContainer = styled(FlexColumn) `
    gap: 2px;
    align-items: start;
    justify-content: center;
`;
export const DocumentSelectionLabelTitle = styled(Subtitle) `
    text-align: start;
    ${(props) => props.opaque &&
    css `
            opacity: 0.5;
        `}
`;
export const DocumentSelectionLabelText = styled(LighterLittleText) `
    text-align: start;
`;
export const PatientConsentErrorIconSmaller = styled(ErrorIcon) `
    width: 20px;
    height: 20px;
    color: ${colors.blue_main};
`;
export const PreviousRecordsExplanationText = styled(LighterLittleText) `
    text-align: start;
`;
